import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { IncomingInvoiceReminderItem } from "@msuite/utils/types";
import { reminderLevelLabel } from "@/components/incoming-invoices";

/** Props Interface */
interface IncomingInvoiceRemindedTagProps {
	reminders: IncomingInvoiceReminderItem[];
}

/** That the supplier has reminded of the invoice, by the highest level reached. */
export function IncomingInvoiceRemindedTag({ reminders }: IncomingInvoiceRemindedTagProps) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	let level: number | null = null;
	for (const reminder of reminders) {
		if (reminder.level !== null && (level === null || reminder.level > level))
			level = reminder.level;
	}

	/** Guard */
	if (!reminders.length) return null;

	/** Render */
	return (
		<Tag
			size="xs"
			color="rose"
			variant="plain"
		>
			{t(reminderLevelLabel(level))}
		</Tag>
	);
}
